module.exports = __webpack_public_path__ + "static/group1_5-f093365b5745ef915929a7cba70d9c00.webp";